import { Icon } from 'components/ui/icon';

interface IProps {
  heading?: string;
  subText?: string;
}

const NoDataAvailable = ({ heading, subText }: IProps) => {
  return (
    <div className="flex flex-col justify-center items-center gap-3 h-[436px]">
      <div className="flex p-4 items-start rounded-full bg-gray-blue-2">
        <Icon name="search" size={40} className="text-icon-gray" />
      </div>
      <div className="mb-5">
        <div className="text-gray-blue-80 text-center font-semibold text-base leading-6">
          {heading || 'No data available'}
        </div>
        <div className="text-gray-blue-70 text-center font-normal text-sm leading-5 mx-auto max-sm:max-w-xs whitespace-normal">
          {subText ||
            'You can try selecting a different filter or a date range'}
        </div>
      </div>
    </div>
  );
};

export default NoDataAvailable;
